import { render, staticRenderFns } from "./stateUpdate.vue?vue&type=template&id=fffb85ba&"
import script from "./stateUpdate.vue?vue&type=script&lang=js&"
export * from "./stateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports